export const getReducedChatIds = (chatIds: string[], deletedChatId: string) =>
  chatIds.filter((id) => id !== deletedChatId);
